import React, { useEffect } from 'react';
import { ToastType } from '../../lib/hooks/useToast';
import { CheckCircle, XCircle, AlertCircle, Info } from 'lucide-react';

interface ToastProps {
  message: string;
  type: ToastType;
  onClose: () => void;
}

const toastStyles = {
  base: 'fixed bottom-4 right-4 flex items-center p-4 rounded-lg shadow-lg transition-all duration-300 transform translate-y-0',
  success: 'bg-green-100 text-green-800 dark:bg-green-800 dark:text-green-100',
  error: 'bg-red-100 text-red-800 dark:bg-red-800 dark:text-red-100',
  warning: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-800 dark:text-yellow-100',
  info: 'bg-blue-100 text-blue-800 dark:bg-blue-800 dark:text-blue-100'
};

const icons = {
  success: <CheckCircle className="w-5 h-5 mr-2" />,
  error: <XCircle className="w-5 h-5 mr-2" />,
  warning: <AlertCircle className="w-5 h-5 mr-2" />,
  info: <Info className="w-5 h-5 mr-2" />
};

export function Toast({ message, type, onClose }: ToastProps) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 3000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className={`${toastStyles.base} ${toastStyles[type]}`}>
      {icons[type]}
      <span className="mr-2">{message}</span>
      <button
        onClick={onClose}
        className="ml-auto focus:outline-none"
        aria-label="Close"
      >
        <XCircle className="w-4 h-4" />
      </button>
    </div>
  );
}

export default Toast;
